import React from "react";
import { fileDownloadUrl } from "@/lib/api";

const COLORS = ["#3B82F6", "#8B5CF6", "#F59E0B", "#10B981", "#EF4444", "#EC4899", "#06B6D4"];

export function resolveImg(src) {
  if (!src) return null;
  if (src.startsWith("file:")) return fileDownloadUrl(src.slice(5));
  return src;
}

function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase() || "?";
}
function colorFor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return COLORS[Math.abs(h) % COLORS.length];
}

export default function UserAvatar({ name, src, size = 40, className = "" }) {
  const s = { width: size, height: size, fontSize: size * 0.4 };
  const resolved = resolveImg(src);
  if (resolved) {
    return <img src={resolved} alt={name} style={s} className={`rounded-full object-cover bg-muted ${className}`} />;
  }
  return (
    <div style={{ ...s, backgroundColor: colorFor(name) }}
      className={`rounded-full flex items-center justify-center text-white font-semibold shrink-0 ${className}`}>
      {initials(name)}
    </div>
  );
}
